import { getNineChapterParams, } from '@didi/webx-js-core';
import { initProduct, initProductV2, initProductV3 } from '../webx';
// init: web sdk初始化-内部方法
const _init = (payload, version, option) => {
    // 根据传入的version版本调用不同的底层API
    const initProductFn = {
        v1: initProduct,
        v2: initProductV2,
        v3: initProductV3,
    };
    const initFn = initProductFn[version];
    let { initOption } = payload;
    if (!initOption)
        initOption = {
            quitInitProduct: false,
            config: { args: {}, need_page_config: true, need_share_config: true },
            env: 'online',
            needPageConfig: true,
            needShareConfig: true
        };
    const { quitInitProduct = false, config = { args: {} }, needPageConfig, needShareConfig, } = initOption;
    /* 九章新增 init过程获取当前产品webx相关配置 */
    if (quitInitProduct !== true) {
        const url = window.location.href;
        const params = Object.assign({
            args: {},
            need_page_config: needPageConfig || false,
            need_share_config: needShareConfig || false,
        }, getNineChapterParams(url), config);
        return initFn(params, option);
    }
};
/**
 * init: web sdk初始化
 * @param payload
 * @param option
 * @example
 * ```js
 *   init({branch: 'passenger'})
 * ```
 */
export const init = (payload, option) => {
    return _init(payload, 'v1', option);
};
export const initV2 = (payload, option) => {
    return _init(payload, 'v2', option);
};
export const initV3 = (payload, option) => {
    return _init(payload, 'v3', option);
};
